<template>
  <div class="animated fadeIn list-of-opi">
    <b-card>
      <div slot="header">Order Pemasangan Iklan (OPI)
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm" :disabled="disabledDelete">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</button>
          <button class="btn btn-primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</button>
          <button class="btn btn-primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</button>
            <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
              <b-row>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label >Nomor OPI</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.orderno" ></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label >Sales Order No.</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.mediaorder" ></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>  
                  <b-input-group >
                    <!-- <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Tgl. OPI</span></b-input-group-prepend> -->
                      <b-input-group-prepend><label >Tanggal OPI</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">s.d</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label>Halaman/Rubrik</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.posisirubrik" ></b-form-input>
                    <b-form-radio-group class="ml-1 mt-2" v-model="tblData.baris" >
                      <b-form-radio value="0">Display & Class.</b-form-radio>
                      <b-form-radio value="1">Baris</b-form-radio>
                      <b-form-radio value="">Semua</b-form-radio>
                    </b-form-radio-group>
                  </b-input-group>
              <b-input-group>
                <b-input-group-prepend><label>Jenis Iklan</label></b-input-group-prepend>
                <b-form-input v-model="tblData.jiklan" @change="tblData.jiklanid=''" ></b-form-input>
                <b-input-group-append>
                  <b-btn variant="primary" text="Button" @click="lkuJenisIklanShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
                <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Judul Iklan</span></b-input-group-prepend>
                <b-form-input v-model="tblData.juduliklan"></b-form-input>
              </b-input-group>
        </b-col>
        <b-col lg="6">
              <b-input-group >
                <b-input-group-prepend><label>Pemasang</label></b-input-group-prepend>
                <b-form-input v-model="tblData.pemasang" @change="tblData.customer_id=''" placeholder="Perushaan Biro Iklan/Perorangan"></b-form-input>
                <b-input-group-append>
                  <b-btn variant="primary" text="Button" @click="lkuCustomerShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
                <b-form-input v-model="tblData.Advertiser" placeholder="Advertiser" class="ml-1"></b-form-input>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend><label>Sales Executive</label></b-input-group-prepend>
            <b-form-input v-model="tblData.salesae_name" placeholder="Sales (AE)" @change="tblData.salesid_id=''"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuSalesShow=true" variant="primary"><i class="fa fa-search"></i></b-btn>
                </b-input-group-append>
                <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Category</span></b-input-group-prepend>
                <b-form-input v-model="tblData.kategori"></b-form-input>
              </b-input-group>

              <b-input-group >
                <b-input-group-prepend><label >Telah diinvoice</label></b-input-group-prepend>
                  <b-form-select v-model="tblData.isinvoiced" :plain="true" :options="YesNoAll"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">Billing Term</span></b-input-group-prepend>
                <b-form-select v-model="tblData.billing" :plain="true" :options="invoicingTerms"></b-form-select>
                <b-input-group-append>
                      <b-button variant="secondary" size="sm" class="ml-1" @click="clearFilter()" >Clear Filter</b-button>
                </b-input-group-append>
              </b-input-group>
              <b-input-group >
                <b-input-group-prepend><label>Bentuk Bayar</label></b-input-group-prepend>
                  <b-form-select v-model="tblData.jenisbayar" :plain="true" :options="paymentForms"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">Komplit Jadwal</span></b-input-group-prepend>
                      <b-form-select v-model="tblData.komplitjadwal" :plain="true" :options="YesNoAll"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">Komplit Realisasi</span></b-input-group-prepend>
                      <b-form-select v-model="tblData.completed" :plain="true" :options="YesNoAll"></b-form-select>
                <b-input-group-append>
                      <b-button variant="success" size="sm" @click="search()" class="ml-2"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
                </b-input-group-append>
              </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print Form</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>          
        <template v-slot:cell(orderdate)="data">
          {{ data.item.orderdate | moment("DD MMM YYYY") }}
        </template>

        <template v-slot:cell(total)="data">
          {{data.item.total | numFormat}}
        </template>
        <template v-slot:cell(jiklan)="data">
          {{data.item.jiklan}} <span v-if="data.item.baris==0"> ({{data.item.jwarna}}) </span>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>        
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true" :lazy="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>   
         <b-modal v-model="lkuJenisIklanShow" size="lg" :hide-footer="true" title="Jenis Iklan" :centered="true" :lazy="true">
            <lku-jenisiklan @click="onSelectLkuJenisIklan" ></lku-jenisiklan>
        </b-modal>  
    <b-modal v-model="lkuSalesShow" size="lg" :hide-footer="true" title="List of Sales Ex." :centered="true">
      <lku-salesae @click="onSelectsales"></lku-salesae>
    </b-modal>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
  </div>
</template>

<style lang="scss">
  .list-of-opi {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: auto;
        }
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
    }
}
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import opi from "../../apis/koran_iklanorder";
import lkuCustomer from "../lookup/lkuCustomer";
import lkuJenisiklan from "../lookup/lkuJenisIklanAll";
import lkuSalesae from "../lookup/lkuSalesae";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";
toastr.init();

export default {
  components: {Loading,lkuCustomer, lkuJenisiklan, lkuSalesae},
  mixins: [validationMixin],
  validations: {
        closeVoidData: {
            closevoidnote: { required },
        },
  }, 
  data() {
    return {
      lkuJenisIklanShow: false,
      lkuCustomerShow: false,
      lkuSalesShow: false,
      showFilter: false,
      showDelConfirm: false,
      disabledDelete:false,
      isLoading:false,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
      tblData: {
        status:"",
        postgroup:"",
        tgl1:'', tgl2:'',
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false
      },
      invoicingTerms:[
          {value:'DI AWAL', text: 'DI AWAL'},
          {value:'PER TERMIN', text: 'PER TERMIN'},
            {value:'PER TAYANG', text: 'PER TAYANG'},
            {value:'PER BULAN', text: 'PER BULAN'},
            {value:'DI AKHIR', text: 'DI AKHIR'},
            {value:'', text: '--semua--'}],
      YesNoAll:[
          {value:'1', text: 'YES'},
            {value:'0', text: 'NO'},
            {value:'', text: 'ALL'}],
      paymentForms:[{value:'STANDARD', text: 'Standard Cash/Bank'}],
      model:{},byae:0
    };
  },
  computed: {
    tblFields(){
      const fields=[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "orderno",
            label: "Order No",
            sortable: true
          },
          {
            key: "orderdate",
            label: "Date",
            sortable: true,
            thStyle: "width:90px",
            thClass: "text-center",
          },
          {
            key: "CustName",
            label: "Pemasang",
            sortable: true
          },
          {
            key: "Advertiser",
            label: "Advertiser",
            sortable: true
          },
          {
            key: "juduliklan",
            label: "Judul Iklan",
          },
          {
            key: "jiklan",
            label: "Jenis Iklan",
            sortable: true
          },
          {
            key: "ukuraniklan",
            label: "Ukuran",
            // thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "platform",
            label: "Platform",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "posisirubrik",
            label: "Posisi",
            // thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "total",
            label: "Amount",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "jmlmuat",
            label: "Freq. Muat",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "jmljadwal",
            label: "Jml. Jadwal",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "realmuat",
            label: "Realisasi Muat",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "SalesEx",
            label: "Sales Ex.",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "mediaorder",
            label: "Sales Order",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "jenisbayar",
            label: "Bentuk Bayar",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },

      ]
      return fields;
    },
  },
  created: async function(){
      if (this.$route.params.byae==1)  {
        this.byae=1;
        this.tblData.createby=this.$store.state.user.username;
      }
       this.$store.commit("opiCbyae", this.$route.name);

        const now = new Date();
        const tgl1 = moment(now).startOf('month').format('YYYY-MM-DD');
        const tgl2 = moment(now).endOf('month').format('YYYY-MM-DD');
        this.tblData.tgl1=this.tblData.tgl1 || tgl1;
        this.tblData.tgl2=this.tblData.tgl2 || tgl2;
    const f = await opi.paymentForms() ;
      this.paymentForms = f.reduce((newArr,item) =>{
          newArr.push(item);
          return newArr;
      },[{ value: '', text: '--- ALL ---'}]);

  },  
  methods: {
    onSelectLkuCustomer: async function (_selected) {
      this.tblData.pemasang = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
      this.tblData.customer_id = _selected.customer_id;
      this.tblData.customer_name = _selected.CustName.trim();
      this.lkuCustomerShow=false;
    },    
    onSelectLkuJenisIklan: async function (_selected) {
      this.tblData.jiklanid = _selected.jiklanid;
      this.tblData.jiklan = _selected.jenisiklan;
      this.lkuJenisIklanShow=false;
    },    
    onSelectsales(_selected) {
      this.tblData.salesae_id = _selected.salesae_id;
      this.tblData.salesae_name = _selected.salesae_name;
      this.lkuSalesShow = false;
    },

    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.KoranOpi) {
            this.tblData[key] = filter.KoranOpi[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.KoranOpi.tgl1 || '';
          this.tblData.tgl2=filter.KoranOpi.tgl2 || '';
          this.showFilter=filtered;
          delete filter.KoranOpi;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.isLoading=true;
      const list = await opi.list(this.tblData);   
      this.isLoading=false;

      return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },

    clearFilter(ctx) {
        this.tblData.juduliklan=  '';
        this.tblData.orderno=  '';
        this.tblData.platform=  '';
        this.tblData.customer_id=  '';
        this.tblData.pemasang=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
      this.tblData.salesae_id = "";
      this.tblData.salesae_name = "";
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    saveFilter() {
      const keys = ['tgl1', 'tgl2','orderdate', 'orderno', 'customer_id', 'platform', 'pemasang', 'Advertiser', 'mediaorder', 'juduliklan', 'brand', 'salesae_id', 'salesae_name', 'billing', 'isinvoiced', 'completed', 'komplitjadwal','createby', 'jenisbayar'];
      let filtered = false;
      const KoranOpi={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              KoranOpi[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          KoranOpi.page=this.tblData.page;
          KoranOpi.limit=this.tblData.limit;
          KoranOpi.sortBy=this.tblData.sortBy;
          KoranOpi.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.KoranOpi=KoranOpi;
          this.$store.commit("filter", filter);
      }
    },    
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },       
    add(){
          this.saveFilter();
          router.push({name :'iklankoran.iklankoranfrm', params: {byae: this.byae}});
    },
    edit: function() {
        if (this.model.orderid) {
          this.saveFilter();
          router.push({name :'iklankoran.iklankoranfrm', params: { orderid: this.model.orderid, byae: this.byae}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.orderid) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        await opi.remove(this.model);
        this.refresh();
        
      } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }           
      }
    },
    rowClicked(record, index) {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
    },
    print: async function()
    {
      if (this.model.orderid) {
          try {
                this.showReport=true;
              this.reportUrl = await opi.print({ orderid: this.model.orderid});
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
              // console.log(error);
          }
        } else {
           this.isLoading=false;
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await opi.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },
    close(){
         router.push({name: "iklankoran.home"});
    }

  }
};
</script>
